module.exports = __webpack_public_path__ + "img/BS-front.01e85f10.png";